// extracted by mini-css-extract-plugin
export default {"button":"unizyPW8xdFPnRmQFRGt","large":"_h1mFDoI306npuhwJ369","small":"CXNQE7AZIoJ4Ztu0dI2I"};